/* eslint-disable */

const DEFAULT_CONSTANTS = {
  INVALID_INPUT_MESSAGE:
    "Input should be a valid number. Please use some common sense or else watch pogo.🙂",
  APP_DESCRIPTION: "Enter your stock details to calculate your profit or loss.",
  DEFAULT_OUTPUT: "NO PAIN NO GAIN AND NO GAIN NO PAIN.🥱",
};

export default DEFAULT_CONSTANTS;
